<script setup>
import ToggleTrackedKeywordImportantToFollowAction from '@frontJs/components/actions/projectManagement/seo/ToggleTrackedKeywordImportantToFollowAction.vue';
import CheckIcon from '@iconify-vue/ph/check';
import XIcon from '@iconify-vue/ph/x';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { useElementHover } from '@vueuse/core';
import { ref } from 'vue';

const { tenant, seoTrackedKeyword, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    seoTrackedKeyword: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: true,
    },
});

const button = ref(null);
const buttonIsHovered = useElementHover(button);
</script>

<template>
    <BaseCell>
        <ToggleTrackedKeywordImportantToFollowAction
            :tenant="tenant"
            :seo-tracked-keyword="seoTrackedKeyword"
            :callback="callback"
        >
            <template #button="{ action }">
                <ActionButton
                    ref="button"
                    size="small"
                    square
                    :title="seoTrackedKeyword.importantToFollow ? 'Non' : 'Oui'"
                    :type="
                        seoTrackedKeyword.importantToFollow
                            ? 'success'
                            : 'danger'
                    "
                    :icon="
                        buttonIsHovered
                            ? seoTrackedKeyword.importantToFollow
                                ? XIcon
                                : CheckIcon
                            : seoTrackedKeyword.importantToFollow
                              ? CheckIcon
                              : XIcon
                    "
                    :callback="() => action()"
                />
            </template>
        </ToggleTrackedKeywordImportantToFollowAction>
    </BaseCell>
</template>
